var map = {
	"./Anyswap.png": 362,
	"./Anyswap.svg": 363,
	"./Artwork.svg": 364,
	"./Artwork_gmx.svg": 365,
	"./Banxa.png": 366,
	"./DROP_DOWN.svg": 203,
	"./Hop.png": 367,
	"./Hop.svg": 368,
	"./Hop_dark.png": 369,
	"./Hop_dark.svg": 370,
	"./Synapse.png": 371,
	"./Synapse.svg": 372,
	"./binance.png": 373,
	"./bitkeep.svg": 374,
	"./bscscan.png": 375,
	"./btn_big_arbitrum.png": 376,
	"./btn_big_avalanche.png": 377,
	"./btn_big_bsc.png": 378,
	"./btn_big_purchasegmx.png": 379,
	"./btn_big_purchasegmx.svg": 380,
	"./buy_gmx.svg": 204,
	"./buy_gmx_bond.svg": 381,
	"./buy_transfer_eth.svg": 382,
	"./coinbaseWallet.png": 205,
	"./coingecko.png": 383,
	"./cross.svg": 384,
	"./flag_en.svg": 385,
	"./flag_es.svg": 386,
	"./flag_fr.svg": 387,
	"./flag_ja.svg": 388,
	"./flag_ko.svg": 389,
	"./flag_ru.svg": 390,
	"./flag_zh.svg": 391,
	"./gateio.svg": 392,
	"./glp_icon.svg": 393,
	"./gmx-logo-final-white-small.png": 394,
	"./gmx-logo-final-white.png": 395,
	"./gmx-logo-final.png": 396,
	"./gmx-logo-glow.png": 397,
	"./gmx-logo-with-name.svg": 206,
	"./gmx_logo.svg": 398,
	"./graphite-01.png": 399,
	"./ic-communityproject.svg": 400,
	"./ic_1inch.svg": 401,
	"./ic_across.svg": 402,
	"./ic_arbitrum_16.svg": 103,
	"./ic_arbitrum_24.svg": 207,
	"./ic_arbitrum_96.svg": 133,
	"./ic_arbitrum_hover_16.svg": 403,
	"./ic_arrowleft16.svg": 404,
	"./ic_arrowright16.svg": 405,
	"./ic_avalanche_16.svg": 104,
	"./ic_avalanche_24.svg": 208,
	"./ic_avalanche_96.svg": 134,
	"./ic_avalanche_testnet_16.svg": 406,
	"./ic_avalanche_testnet_24.svg": 407,
	"./ic_avalanche_testnet_96.svg": 408,
	"./ic_avax_24.svg": 409,
	"./ic_avax_30.svg": 410,
	"./ic_avax_40.svg": 411,
	"./ic_banxa.svg": 175,
	"./ic_binance.svg": 209,
	"./ic_binance_logo.svg": 412,
	"./ic_bome_24.png": 413,
	"./ic_bome_40.png": 414,
	"./ic_bonk_24.png": 415,
	"./ic_bonk_40.png": 416,
	"./ic_bsc.svg": 417,
	"./ic_bsc_96.svg": 418,
	"./ic_btc.b_24.svg": 419,
	"./ic_btc.b_40.svg": 420,
	"./ic_btc_24.svg": 421,
	"./ic_btc_40.svg": 422,
	"./ic_bungee.png": 176,
	"./ic_busd_24.svg": 423,
	"./ic_buy_glp.svg": 210,
	"./ic_bybit.svg": 424,
	"./ic_cash.png": 425,
	"./ic_cash.svg": 426,
	"./ic_checked.svg": 211,
	"./ic_coingecko_16.svg": 212,
	"./ic_coingecko_hover_16.svg": 427,
	"./ic_convert_down.svg": 213,
	"./ic_copy_16.svg": 214,
	"./ic_corgiai_24.png": 428,
	"./ic_corgiai_40.png": 429,
	"./ic_cost.svg": 215,
	"./ic_dai_24.svg": 430,
	"./ic_dai_40.svg": 431,
	"./ic_discord.svg": 432,
	"./ic_dodo.svg": 433,
	"./ic_eth_24.svg": 434,
	"./ic_eth_40.svg": 435,
	"./ic_firebird.png": 436,
	"./ic_floki_24.png": 437,
	"./ic_floki_40.png": 438,
	"./ic_frax_24.svg": 439,
	"./ic_frax_40.svg": 440,
	"./ic_fusd_40.svg": 441,
	"./ic_fuse_16.svg": 177,
	"./ic_fuse_24.svg": 266,
	"./ic_fuse_40.svg": 442,
	"./ic_fuse_96.svg": 443,
	"./ic_fuse_sparknet.svg": 444,
	"./ic_github.svg": 445,
	"./ic_glp_24.svg": 178,
	"./ic_glp_40.svg": 165,
	"./ic_glp_custom.svg": 216,
	"./ic_gmx.svg": 446,
	"./ic_gmx_24.svg": 447,
	"./ic_gmx_30.svg": 448,
	"./ic_gmx_40.svg": 267,
	"./ic_gmx_64.svg": 449,
	"./ic_gmx_arbitrum.svg": 450,
	"./ic_gmx_avax.svg": 451,
	"./ic_gmx_big.svg": 452,
	"./ic_gmx_custom.svg": 217,
	"./ic_gmx_footer.svg": 453,
	"./ic_hop.svg": 454,
	"./ic_huobi.svg": 455,
	"./ic_info.svg": 456,
	"./ic_kucoin.svg": 457,
	"./ic_language24.svg": 149,
	"./ic_link_24.svg": 458,
	"./ic_link_40.svg": 459,
	"./ic_liquidity.svg": 218,
	"./ic_matcha.png": 460,
	"./ic_medium.svg": 219,
	"./ic_meme_24.png": 461,
	"./ic_meme_40.png": 462,
	"./ic_menu_dots.svg": 463,
	"./ic_metamask_16.svg": 220,
	"./ic_metamask_hover_16.svg": 464,
	"./ic_mim_24.svg": 465,
	"./ic_mim_40.svg": 466,
	"./ic_multiswap.svg": 467,
	"./ic_new_link_16.svg": 221,
	"./ic_o3.png": 179,
	"./ic_odos.png": 468,
	"./ic_olympus.svg": 469,
	"./ic_olympus_arbitrum.svg": 222,
	"./ic_openocean.svg": 470,
	"./ic_paraswap.svg": 471,
	"./ic_pepe_24.png": 472,
	"./ic_pepe_40.png": 473,
	"./ic_selector_dropdowns.svg": 474,
	"./ic_settings_16.svg": 180,
	"./ic_settings_24.svg": 475,
	"./ic_sign in_16.svg": 476,
	"./ic_sign_out_16.svg": 223,
	"./ic_simpleswaps.svg": 224,
	"./ic_slingshot.svg": 477,
	"./ic_stats.svg": 225,
	"./ic_stats_big.svg": 478,
	"./ic_synapse.svg": 479,
	"./ic_telegram.svg": 480,
	"./ic_tether_24.svg": 481,
	"./ic_tokens.svg": 482,
	"./ic_totaluser.svg": 226,
	"./ic_traderjoe.png": 227,
	"./ic_trading.svg": 228,
	"./ic_transfer_avax.svg": 483,
	"./ic_twitter.svg": 229,
	"./ic_uni_24.svg": 484,
	"./ic_uni_40.svg": 485,
	"./ic_uni_arbitrum.svg": 230,
	"./ic_usdc.e_24.svg": 486,
	"./ic_usdc.e_40.svg": 487,
	"./ic_usdc_24.svg": 488,
	"./ic_usdc_40.svg": 489,
	"./ic_usdt_24.svg": 490,
	"./ic_usdt_40.svg": 491,
	"./ic_wallet_24.svg": 231,
	"./ic_wavax_24.svg": 492,
	"./ic_wavax_40.svg": 493,
	"./ic_wbtc_24.svg": 494,
	"./ic_wbtc_40.svg": 495,
	"./ic_weth_24.svg": 496,
	"./ic_weth_40.svg": 497,
	"./ic_wfuse_40.svg": 498,
	"./ic_wif_24.png": 499,
	"./ic_wif_40.png": 500,
	"./ic_yield_yak.png": 501,
	"./lg_arbitrum.svg": 502,
	"./logo_VLX.svg": 90,
	"./logo_VLX_small.svg": 181,
	"./long.svg": 232,
	"./metamask-text.svg": 503,
	"./metamask.png": 233,
	"./nansen_portfolio.svg": 234,
	"./page-not-found.svg": 504,
	"./position-share-bg.png": 235,
	"./short.svg": 236,
	"./swap.svg": 237,
	"./trading.jpg": 505,
	"./wallet-connect-text.svg": 506,
	"./walletconnect-circle-blue.svg": 238,
	"./wave-01.png": 507,
	"./wave-02.png": 508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;